/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';
import { IconAccount, IconPartnership } from '@americanexpress/dls-react';

// models and services
import { DLSSize } from 'src/types/dls-size.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import MixpanelService from 'src/services/mixpanel.service';
import { SelectCardViewModel } from 'src/types/view-models/select-card.view.model';
import { WhoViewModel } from 'src/types/view-models/onboarding/who.view.model';

// components
import OnboardingButtons from 'src/components/onboarding-buttons/OnboardingButtons';
import SelectCard from 'src/components/atomic/molecules/select-card/SelectCard';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import WideView from 'src/components/atomic/layouts/wideView/WideView';

// icons and styles
import styles from './Who.module.scss';

export default function Who({ handleUpdateUserAttribute, next, back }: WhoViewModel): JSX.Element {
    const title: string = LiteralsService.getLiteral('Onboarding.who.title');
    const subtitleElement: JSX.Element = (
        <Typography variant={TypographyVariants.BODY} className={styles.subtitleElement}>
            {LiteralsService.getLiteral('Onboarding.who.tabDesc')}
        </Typography>
    );

    const handleClick = async (startupJustMe: boolean): Promise<void> => {
        handleUpdateUserAttribute('startupJustMe', startupJustMe);
        MixpanelService.track('o4 Single');
        MixpanelService.track('o4 Who Are You Planning Complete');
        await next();
    };

    const cardDetails: SelectCardViewModel[] = [
        {
            title: LiteralsService.getLiteral('Onboarding.who.justMe'),
            description: LiteralsService.getLiteral('Onboarding.who.justMeDesc'),
            icon: <IconAccount size={DLSSize.MEDIUM} filled />,
            onClick: () => {
                void handleClick(true);
            }
        },
        {
            title: LiteralsService.getLiteral('Onboarding.who.myselfOthers'),
            description: LiteralsService.getLiteral('Onboarding.who.myselfOthersDesc'),
            icon: <IconPartnership size={DLSSize.MEDIUM} filled />,
            onClick: () => {
                void handleClick(false);
            }
        }
    ];

    return (
        <WideView
            title={title}
            subtitleElement={subtitleElement}
            classNameView="onboarding-drawer whoView"
            hideBackButton
            hasBackgroundBanner
            showFooter
        >
            <div className={styles.whoView}>
                <div className={styles.contentArea}>
                    {cardDetails.map((cardDetail: SelectCardViewModel, index: number) => {
                        return (
                            <SelectCard
                                title={cardDetail.title}
                                description={cardDetail.description}
                                icon={cardDetail.icon}
                                onClick={cardDetail.onClick}
                                key={`SelectCard-${index}`}
                            />
                        );
                    })}
                </div>
                <OnboardingButtons back={back} backButtonEventName={'o4 Who Are You Planning Back'} isWideView />
            </div>
        </WideView>
    );
}
